/* eslint-disable @next/next/no-img-element */
/* eslint-disable space-before-blocks */
/* eslint-disable max-len */
/* eslint-disable no-unused-expressions */
/* eslint-disable array-callback-return */
import React from 'react';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import isBetween from 'dayjs/plugin/isBetween';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import cx from 'classnames';
import dynamic from 'next/dynamic';
import Button from '@common_button';
import CmsRenderer from '@core_modules/cms/components/cms-renderer';
import Show from '@common_show';
import { getMpDailyDeals } from '@core_modules/catalog/services/graphql';
import { basePath } from '@config';

const MagezonProduct = dynamic(() => import('@core_modules/cms/components/cms-renderer/magezon/MagezonProduct'));
const CountDownTimer = dynamic(() => import('@common/CountDownTimer'));

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(duration);
dayjs.extend(isBetween);

const FlashSale = (props) => {
    const {
        isPdp,
        isPlp,
        isActive,
        content,
        storeConfig,
        classWrapper,
        classWrapperHeader,
        ProductSku = [],
    } = props;

    dayjs.tz.setDefault(storeConfig.timezone);
    const saleEnabled = storeConfig.mp_dailydeal_enabled || false;
    const mainTime = storeConfig.mp_dailydeal_custom_timesale || '';
    const timePeriod = storeConfig.mp_dailydeal_custom_timesale_period || '';

    const [showContent, setShowContent] = React.useState(false);
    const [expiredTime, setExpiredTime] = React.useState(false);
    const [timerRange, setTimerRange] = React.useState(null);
    const flashsaleProductSkuList = [];

    const dateFrom = timerRange && timerRange.begin.format('YYYY-MM-DD HH:mm:ss');
    const dateTo = timerRange && timerRange.end.format('YYYY-MM-DD HH:mm:ss');
    const dateTimer = timerRange && timerRange.timer;

    const [onGetMpDailyDeals, { data: mpData, loading: mpLoading, error: mpError }] = getMpDailyDeals();
    mpData?.MpDailyDeals?.items?.map((item) => {
        if (ProductSku.length === 0) {
            flashsaleProductSkuList.push(item.product_sku);
        } else if (ProductSku.includes(item.product_sku)) {
            flashsaleProductSkuList.push(item.product_sku);
        }
    });
    const saleCount = mpData && mpData.MpDailyDeals && mpData.MpDailyDeals.total_count;
    // const labelHomepage = mpData && mpData.MpDailyDeals && mpData.MpDailyDeals.label_homepage;
    // const labelPDP = mpData && mpData.MpDailyDeals && mpData.MpDailyDeals.label_pdp;
    // const labelPLP = mpData && mpData.MpDailyDeals && mpData.MpDailyDeals.label_plp;
    const isEnabled = !expiredTime && saleEnabled && !mpLoading && !mpError && saleCount !== 0 && mainTime.length && flashsaleProductSkuList.length > 0;
    const isExpired = expiredTime && saleEnabled && mainTime.length;

    // const label = t('common:label:flashsale'); // labelHomepage || t('common:label:flashsale') || '';
    // if (isPdp) label = labelPDP;
    // else if (isPlp) label = labelPLP;

    React.useEffect(() => {
        if (dateFrom && dateTo) {
            onGetMpDailyDeals({
                variables: {
                    pageSize: 100,
                    currentPage: 1,
                },
            });
        }
    }, [dateFrom, dateTo]);

    React.useEffect(() => {
        const currentDate = dayjs.tz();
        const dateNow = dayjs.tz().startOf('date');
        const halfDay = dateNow.add(12, 'hours');
        const fullDay = dateNow.add(1, 'days');

        let timeBegin = '';
        let timeEnd = '';
        const timeStart = mainTime;

        if (mainTime.length) {
            const beginArr = [];
            const endArr = [];

            mainTime.forEach((time) => {
                const splitTime = time.split(':');
                const date = dateNow.add(dayjs.duration().add({ hours: splitTime[0], minutes: splitTime[1] }).add(timePeriod, 'hours'));
                const dateTime = date.format('HH:mm');
                beginArr.push(dateTime);
                endArr.push(dateTime);
            });

            beginArr.unshift(beginArr.pop());
            timeBegin = beginArr;
            timeEnd = endArr;
        }

        const groupingTime = (begin, start, end) => {
            const gt = [];
            for (let i = 0; i < timeStart.length; i += 1) {
                gt.push({
                    begin: begin[i],
                    start: start[i],
                    end: end[i],
                });
            }
            return gt;
        };

        groupingTime(timeBegin, timeStart, timeEnd).forEach((time) => {
            const splitTimeBegin = timeBegin.length > 1 ? time.begin.split(':') : time.start.split(':');
            const splitTimeStart = time.start.split(':');
            const splitTimeEnd = time.end.split(':');

            const dateBegin = dateNow.add(dayjs.duration().add({ hours: splitTimeBegin[0], minutes: splitTimeBegin[1] }));
            const dateStart = dateNow.add(dayjs.duration().add({ hours: splitTimeStart[0], minutes: splitTimeStart[1] }));
            const dateEnd = dateNow.add(dayjs.duration().add({ hours: splitTimeEnd[0], minutes: splitTimeEnd[1] }));

            let tBegin = '';
            let tStart = '';
            let tEnd = '';

            if (splitTimeBegin > splitTimeStart) {
                if (currentDate.isBetween(dateNow, halfDay, null, '[)')) {
                    tBegin = dateBegin.subtract(1, 'days');
                    tStart = dateStart;
                    tEnd = dateEnd;
                }
                if (currentDate.isBetween(halfDay, fullDay, null, '[)')) {
                    tBegin = dateBegin;
                    tStart = dateStart.add(1, 'days');
                    tEnd = dateEnd.add(1, 'days');
                }
            } else if (splitTimeStart > splitTimeEnd) {
                if (currentDate.isBetween(dateNow, halfDay, null, '[)')) {
                    tBegin = dateBegin.subtract(1, 'days');
                    tStart = dateStart.subtract(1, 'days');
                    tEnd = dateEnd;
                }
                if (currentDate.isBetween(halfDay, fullDay, null, '[)')) {
                    tBegin = dateBegin;
                    tStart = dateStart;
                    tEnd = dateEnd.add(1, 'days');
                }
            } else {
                tBegin = dateBegin;
                tStart = dateStart;
                tEnd = dateEnd;
            }

            if (currentDate.isBetween(tBegin, tEnd, null, '[)')) {
                if (currentDate.isBetween(tBegin, tStart, null, '[)')) {
                    const timer = {
                        begin: dayjs.tz(tBegin),
                        start: dayjs.tz(tStart),
                        end: dayjs.tz(tEnd),
                        timer: dayjs.tz(tStart),
                        sale: false,
                    };
                    setTimerRange(timer);
                }
                if (currentDate.isBetween(tStart, tEnd, null, '[)')) {
                    const timer = {
                        begin: dayjs.tz(tBegin),
                        start: dayjs.tz(tStart),
                        end: dayjs.tz(tEnd),
                        timer: dayjs.tz(tEnd),
                        sale: true,
                    };
                    setTimerRange(timer);
                }
            }
        });
    }, [expiredTime]);

    React.useEffect(() => {
        if (isExpired) {
            window.location.reload();
        }
    }, [isExpired]);

    const productProps = {
        item_lg: 4,
        item_md: 3,
        item_sm: 2,
        item_xl: 4,
        item_xs: 2,
        type: 'product_grid',
        flashsale_product_sku_list: flashsaleProductSkuList,
    };

    if (!isEnabled) return null;

    if (!isActive) return null;

    if (isPdp || isPlp) {
        return (
            <div
                className={
                    cx(
                        isPdp && 'flash-sale-block-pdp flex flex-col items-center',
                        isPlp && 'flash-sale-block-plp',
                        classWrapper,
                    )
                }
            >
                <div className={
                    cx(
                        'flash-sale-header flex justify-center items-center mb-space-800 max-[375px]:flex-col max-[375px]:gap-[10px]',
                        classWrapperHeader,
                    )
                }
                >
                    <div className={
                        cx(
                            'flash-sale-title font-semibold mr-[16px]',
                        )
                    }
                    >
                        <img src={`${basePath}/assets/img/flash_sale.png`} alt="Flash Sale" className="desktop:max-w-[150px] tablet:max-w-[150px] mobile:max-w-[100px] h-auto" />
                    </div>
                    <CountDownTimer
                        targetDate={dateTimer}
                        setExpiredTime={setExpiredTime}
                        className={
                            cx(
                                isPlp && 'mb-0',
                            )
                        }
                    />
                    <Show when={content}>
                        <Button
                            variant="plain"
                            className="!p-2"
                            onClick={() => setShowContent(!showContent)}
                        >
                            {
                                React.cloneElement((
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M5.23017 7.20938C5.52875 6.92228 6.00353 6.93159 6.29063 7.23017L10 11.1679L13.7094 7.23017C13.9965 6.93159 14.4713 6.92228 14.7698 7.20938C15.0684 7.49647 15.0777 7.97125 14.7906 8.26983L10.5406 12.7698C10.3992 12.9169 10.204 13 10 13C9.79599 13 9.60078 12.9169 9.45938 12.7698L5.20938 8.26983C4.92228 7.97125 4.93159 7.49647 5.23017 7.20938Z" fill="#4B5563" />
                                    </svg>
                                ))
                            }
                        </Button>
                    </Show>
                </div>
                <Show when={content && showContent}>
                    <div className="content-flashsale [&_.prose]:mx-auto mb-4 shadow-md px-4 py-2 w-full rounded-md">
                        <CmsRenderer content={content} storeConfig={storeConfig} />
                    </div>
                </Show>
                {/* <Show when={isPdp}>
                    <Divider className="desktop:mt-5 desktop:mb-6 tablet:mt-5 tablet:mb-6 mobile:mt-3 mobile:mb-3" />
                </Show> */}
            </div>
        );
    }

    return (
        <div
            className={
                cx('flash-sale-block', classWrapper)
            }
        >
            <div className={
                cx(
                    'flash-sale-header flex justify-center items-center mb-space-800 mb-4',
                    classWrapperHeader,
                )
            }
            >
                <div className="flas-sale-title font-semibold mr-[16px]"><img src={`${basePath}/assets/img/flash_sale.png`} alt="Flash Sale" className="desktop:max-w-[150px] tablet:max-w-[150px] mobile:max-w-[100px] h-auto" /></div>
                <CountDownTimer useUnit targetDate={dateTimer} setExpiredTime={setExpiredTime} />
            </div>
            <MagezonProduct {...props} {...productProps} />
        </div>
    );
};

export default FlashSale;
